/// <amd-module name="Feed/Legacy/DataServices/ProvenanceDataService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";

import { PackageVersionProvenance } from "Feed/Common/Contracts/Feed";
import { getFeedClient, IFeedRestClient } from "Feed/Common/RestClient/Feed";

export interface IFeedProvenanceDataService extends IVssService {
    getPackageVersionProvenance(
        projectId: string,
        feedId: string,
        packageId: string,
        versionId: string
    ): Promise<PackageVersionProvenance>;
}

export class ProvenanceDataService extends VssService implements IFeedProvenanceDataService {
    public async getPackageVersionProvenance(
        projectId: string,
        feedId: string,
        packageId: string,
        versionId: string
    ): Promise<PackageVersionProvenance> {
        return this.FeedRestClient.getPackageVersionProvenance(feedId, packageId, versionId, projectId);
    }

    private get FeedRestClient(): IFeedRestClient {
        return getFeedClient(this.pageContext);
    }
}

Services.add("IFeedProvenanceDataService", { serviceFactory: ProvenanceDataService });
